export const CORRECT_PASSWORD = 'Oaxaca2026'
